import type { UseMutationOptions } from "@suse-o11y/query";

import { createSilencingRuleFn, deleteSilencingRuleFn } from "../common/openapi";
import type { CreateSilencingRule } from "../common/openapi/models";

export const createSilencingRule = {
	mutationKey: ["silencing-rules", "create"],
	mutationFn: async (rule) => {
		await createSilencingRuleFn({ body: rule });
	},
} satisfies UseMutationOptions<void, Error, CreateSilencingRule>;

export const deleteSilencingRule = {
	mutationKey: ["silencing-rules", "delete"],
	mutationFn: async (identifier) => {
		await deleteSilencingRuleFn({ identifier });
	},
} satisfies UseMutationOptions<void, Error, string>;
